export default "__VITE_ASSET__XXY2IRyG__"